import { initializeApp } from "firebase/app";
import {getFirestore } from "@firebase/firestore";


const firebaseConfig = {
    apiKey: "AIzaSyA6fqK9Ne1vSqkNsY-PITy2344wmBvrOPM",
    authDomain: "tasnim-s-akash.firebaseapp.com",
    projectId: "tasnim-s-akash",
    storageBucket: "tasnim-s-akash.appspot.com",
    messagingSenderId: "404161573717",
    appId: "1:404161573717:web:1e07199771f19567a935dc",
    measurementId: "G-MRKY16E4K3"
  };

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);